"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminCancellationReasonTranslation = void 0;
exports.adminCancellationReasonTranslation = [
    { code: 'NO_DRIVER_HQ_AROUND', label: 'Absence de chauffeurs dans notre QG (rayon de 20 KM)' },
    { code: 'DRIVER_BUSY', label: 'Créneaux indisponibles sur plannings chauffeurs / déjà occupés' },
    { code: 'OUTSOURCE_UNAVAILABLE', label: 'Indisponibilité de la sous-traitance' },
    { code: 'NO_DRIVER_HQ_PANEL', label: 'Absence chauffeurs dans le QG pour la gamme commandée' },
    { code: 'PRICING_INNAPPROPRIATE', label: 'Refus pricing de la course' },
    {
        code: 'OPERATIONAL_ISSUE',
        label: 'Erreur opérationnelle (dispatche serré et/ou sans informer le chauffeur, chevauchement non détecté, retard non détecté, demande de rappelle non traitée…)',
    },
    { code: 'LATE_DRIVER_DEFAULT', label: "Plantage chauffeur tardif (refus d'honorer la course, retard, redispache, litige…)" },
    {
        code: 'INVOICING_TO_INVALIDATE',
        label: 'A ne pas facturer au client (contestation légitimes du passager sur sa commande initiale : lieu de PEC, comportement chauffeur durant la course…)',
    },
];
